import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ModalData {
  title: string;
  closeButtonLabel?: string;
  saveButtonLabel?: string;
  content: string;
  htmlContent?: HTMLElement;
  url?: string;
}

export interface AsyncModalData extends ModalData {
  isAsync?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorModalService {
  private _showModal = new Subject<AsyncModalData | undefined>();
  private _modalResult = new Subject<boolean>();
  showModal$ = this._showModal.asObservable();
  modalResult$ = this._modalResult.asObservable();

  openModal(data?: ModalData): void {
    this._showModal.next(data);
  }

  openAsync(data: ModalData): Promise<boolean> {
    return new Promise((resolve) => {
      const asyncData: AsyncModalData = { ...data, isAsync: true };
      this._showModal.next(asyncData);

      const subscription = this.modalResult$.subscribe((result: boolean) => {
        subscription.unsubscribe();
        resolve(result);
      });
    });
  }

  closeModal(): void {
    this._showModal.next(undefined);
  }

  resolveModal(result: boolean): void {
    this._modalResult.next(result);
    this.closeModal();
  }
}
